// Need to support `app.inlt.com` and `cbms.inlt.com`
export const getIsHostCbms = (): boolean => {
  const host = window.location.hostname;
  return (
    (host.includes('cbms') || host.includes('app')) && host.includes('inlt.com')
  );
};
